function _isNumber(x) {
  return Object.prototype.toString.call(x) === '[object Number]';
}
module.exports = _isNumber;


//////////////////
// WEBPACK FOOTER
// ./node_modules/ramda/src/internal/_isNumber.js
// module id = 151
// module chunks = 0